import React, { useCallback, useState } from 'react';

import ContactSalesDialog from '../components/ContactSalesDialog';

export default function useContactSalesDialog() {
    const [isOpen, setIsOpen] = useState(false);

    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);

    const dialog = <ContactSalesDialog isOpen={isOpen} onClose={close} />;

    return [dialog, open] as const;
}
